import { inject, Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { AuthState, OktaAuth } from '@okta/okta-auth-js';

@Injectable({
  providedIn: 'root',
})
export class CommonserviceService {
  readonly dialog = inject(MatDialog);
  constructor(
    public _oktaStateService: OktaAuthStateService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {}

  async logout() {
    await this.oktaAuth.signOut();
  }
}
